import { Component, Input, TemplateRef, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-wrapper',
  template: `
    <div class="modal-header" [class.border-bottom-0]="noBorder" [class.pb-0]="noBorder">
      <div class="d-flex align-items-center" [class.flex-column]="subtitle" [class.align-items-start]="subtitle">
        <h5 class="modal-title font-weight-bolder d-flex align-items-center mb-0" [ngClass]="titleClass">
          <lucide-angular
            *ngIf="icon"
            [name]="icon"
            [size]="iconSize || 18"
            class="mr-25"
            [ngClass]="iconColor ? '' : (titleClass ? titleClass : 'text-primary')"
            [ngStyle]="iconColor ? { color: iconColor } : null"
          ></lucide-angular>
          <span>{{ title }}</span>
        </h5>
        <small *ngIf="subtitle" class="text-secondary mt-25 font-small-3">{{ subtitle }}</small>
      </div>
      <button
        *ngIf="showClose"
        type="button"
        class="btn btn-sm btn-icon btn-flat-danger"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
        title="Đóng"
        rippleEffect
      >
        <lucide-angular name="x" size="18"></lucide-angular>
      </button>
    </div>

    <!-- Body: nếu hasBodyWrapper=true (mặc định) thì bọc trong .modal-body, nếu false thì render thẳng -->
    <div *ngIf="hasBodyWrapper" class="modal-body" [ngClass]="bodyClass">
      <ng-container
        *ngTemplateOutlet="contentTemplate; context: { $implicit: activeModal, modal: activeModal }"
      ></ng-container>
    </div>
    <ng-container *ngIf="!hasBodyWrapper">
      <ng-container
        *ngTemplateOutlet="contentTemplate; context: { $implicit: activeModal, modal: activeModal }"
      ></ng-container>
    </ng-container>

    <!-- Footer tùy chọn nếu có truyền footerTemplate -->
    <div *ngIf="footerTemplate" class="modal-footer" [ngClass]="footerClass">
      <ng-container
        *ngTemplateOutlet="footerTemplate; context: { $implicit: activeModal, modal: activeModal }"
      ></ng-container>
    </div>
  `,
  encapsulation: ViewEncapsulation.None
})
export class ModalWrapperComponent {
  @Input() title: string = '';
  @Input() titleClass: string = '';
  @Input() subtitle?: string;
  @Input() icon?: string;
  @Input() iconSize: number = 18;
  @Input() iconColor?: string;
  @Input() showClose: boolean = true;
  @Input() noBorder: boolean = false;
  @Input() bodyClass: string = '';
  @Input() footerClass: string = '';
  @Input() hasBodyWrapper: boolean = true;
  @Input() contentTemplate!: TemplateRef<any>;
  @Input() footerTemplate?: TemplateRef<any>;

  constructor(public activeModal: NgbActiveModal) {}
}
